// import React, { useEffect, useState } from "react";
// import { collection, addDoc, Timestamp, getDocs } from "firebase/firestore";
// import { db } from "../firebase";
// import "../css/collection.css";
// import { useSelector } from "react-redux";

// const Collection = () => {
//   const currentTheme = useSelector((state) => state.theme.current);

//   const [data, setData] = useState({
//     date: "",
//     amount: "",
//     type: "",
//   });
//   const [collections, setCollections] = useState([]);
//   const [isDate, setIsDate] = useState("");

//   const handleSubmit = () => {
//     const amt = data.amount.trim();
//     const typ = data.type.trim();

//     if (amt === "" || typ === "") {
//       alert("Enter amount and type");
//       return;
//     }

//     setData({
//       date: "",
//       amount: "",
//       type: "",
//     });

//     addCollection();
//   };

//   const addCollection = async () => {
//     try {
//       await addDoc(collection(db, "Collection"), {
//         date: data.date || Timestamp.now(),
//         amount: data.amount,
//         type: data.type,
//       });
//     } catch (error) {
//       alert("Operation not allowed for viewers");
//     }
//   };

//   useEffect(() => {
//     const fetchCollection = async () => {
//       const snapshot = await getDocs(collection(db, "Collection"));
//       const data = snapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setCollections(data);
//     };

//     fetchCollection();
//   }, []);

//   return (
//     <div className="collection-container">
//       <h2>Collection</h2>

//       <div
//         className="collection-form"
//         style={{ backgroundColor: `${currentTheme}` }}
//       >
//         <div className="collection-date">
//           Default: Todays Date.
//           <input
//             disabled={!isDate}
//             type="date"
//             placeholder="Enter Date"
//             value={data.amount}
//             onChange={(e) => setData({ ...data, date: e.target.value })}
//           />
//           <small>{data.date}</small>
//           <label htmlFor="date">
//             Change Date &nbsp;
//             <input
//               id="date"
//               type="checkbox"
//               onChange={(e) => setIsDate(e.target.checked)}
//             />
//           </label>
//         </div>

//         <input
//           type="text"
//           placeholder="Enter amount"
//           value={data.amount}
//           onChange={(e) => setData({ ...data, amount: e.target.value })}
//         />

//         <input
//           type="text"
//           placeholder="Enter type"
//           value={data.type}
//           onChange={(e) => setData({ ...data, type: e.target.value })}
//         />

//         <button onClick={() => handleSubmit()}>Submit</button>
//       </div>

//       <h2>Collections</h2>
//       <div className="collection-card">
//         {collections.map((collection) => (
//           <div
//             className="collection-content"
//             key={collection.id}
//             style={{ backgroundColor: `${currentTheme}` }}
//           >
//             <p>
//               Date:{" "}
//               {collection.date?.toDate
//                 ? collection.date?.toDate()?.toDateString()
//                 : collection.date}
//             </p>
//             <p>Amount: ₹{collection.amount}</p>
//             <p>Type: {collection.type}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Collection;


import React, { useEffect, useState } from "react";
import { collection, addDoc, getDocs, Timestamp, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";
import { toast, ToastContainer } from "react-toastify";
import "../css/datapanel.css";
import "../css/collection.css";

const COLLECTION_TYPES = [
  "Zakat","Fitrah","Sadaqah","Khums (Sehme Sadaat)","Fidaya",
  "Kaffara","Qurbani","General Donation","Ration Fund","Medical Fund","Education Fund","Other",
];

const Collection = () => {
  const [collections, setCollections]   = useState([]);
  const [loading, setLoading]           = useState(true);
  const [showForm, setShowForm]         = useState(false);
  const [search, setSearch]             = useState("");
  const [typeFilter, setTypeFilter]     = useState("all");
  const [sortOrder, setSortOrder]       = useState("desc");
  const [expanded, setExpanded]         = useState(null);

  const [form, setForm] = useState({
    date: new Date().toISOString().split("T")[0],
    amount: "",
    type: "",
    notes: "",
    useCustomDate: false,
  });

  useEffect(() => { fetchCollections(); }, [sortOrder]);

  const fetchCollections = async () => {
    setLoading(true);
    try {
      const q    = query(collection(db, "Collection"), orderBy("date", sortOrder));
      const snap = await getDocs(q);
      setCollections(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (err) { toast.error("Failed to load collections."); }
    setLoading(false);
  };

  const handleSubmit = async () => {
    if (!form.amount.trim() || !form.type.trim()) {
      toast.error("Amount and type are required.");
      return;
    }
    try {
      await addDoc(collection(db, "Collection"), {
        date:   form.useCustomDate ? Timestamp.fromDate(new Date(form.date)) : Timestamp.now(),
        amount: form.amount,
        type:   form.type,
        notes:  form.notes,
      });
      toast.success("Collection entry added.");
      setForm({ date: new Date().toISOString().split("T")[0], amount:"", type:"", notes:"", useCustomDate:false });
      setShowForm(false);
      fetchCollections();
    } catch { toast.error("Failed to add. Please try again."); }
  };

  const totalAmount = collections
    .filter(c => typeFilter === "all" || c.type === typeFilter)
    .reduce((sum, c) => sum + (parseFloat(c.amount) || 0), 0);

  const uniqueTypes = [...new Set(collections.map(c => c.type).filter(Boolean))];

  const filtered = collections.filter(c => {
    if (typeFilter !== "all" && c.type !== typeFilter) return false;
    if (search) {
      const s = search.toLowerCase();
      if (!(c.type||"").toLowerCase().includes(s) && !(c.amount||"").toString().includes(s) && !(c.notes||"").toLowerCase().includes(s)) return false;
    }
    return true;
  });

  const formatDate = ts => {
    if (!ts) return "—";
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString("en-IN", { day:"2-digit", month:"short", year:"numeric" });
  };

  return (
    <div className="dp-root">
      <ToastContainer />

      {/* Header */}
      <div className="dp-header">
        <div className="dp-header-left">
          <span className="dp-header-icon">💰</span>
          <div>
            <h2 className="dp-title">Collection</h2>
            <p className="dp-subtitle">Track donations, zakat, and all financial collections</p>
          </div>
        </div>
        <div className="dp-header-btns">
          <button className="dp-refresh-btn" onClick={fetchCollections}>↻ Refresh</button>
          <button className="dp-add-btn" onClick={() => setShowForm(v => !v)}>
            {showForm ? "✕ Close" : "+ Add Entry"}
          </button>
        </div>
      </div>

      {/* Add Entry Form */}
      {showForm && (
        <div className="cl-add-form">
          <h3 className="cl-form-title">New Collection Entry</h3>
          <div className="cl-form-grid">
            <div className="cl-form-field">
              <label>Amount (₹) *</label>
              <input
                type="number"
                placeholder="Enter amount"
                value={form.amount}
                onChange={e => setForm(p => ({...p, amount: e.target.value}))}
              />
            </div>
            <div className="cl-form-field">
              <label>Type *</label>
              <select value={form.type} onChange={e => setForm(p => ({...p, type: e.target.value}))}>
                <option value="">Select type</option>
                {COLLECTION_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div className="cl-form-field">
              <label>Notes</label>
              <input
                placeholder="Optional notes"
                value={form.notes}
                onChange={e => setForm(p => ({...p, notes: e.target.value}))}
              />
            </div>
            <div className="cl-form-field">
              <label>
                <input
                  type="checkbox"
                  checked={form.useCustomDate}
                  onChange={e => setForm(p => ({...p, useCustomDate: e.target.checked}))}
                  style={{marginRight:"0.4rem"}}
                />
                Custom Date
              </label>
              {form.useCustomDate && (
                <input
                  type="date"
                  value={form.date}
                  onChange={e => setForm(p => ({...p, date: e.target.value}))}
                />
              )}
              {!form.useCustomDate && <span className="cl-date-note">Using today's date</span>}
            </div>
          </div>
          <div className="cl-form-actions">
            <button className="dp-cancel-btn" onClick={() => setShowForm(false)}>Cancel</button>
            <button className="dp-save-btn" onClick={handleSubmit}>Add Entry</button>
          </div>
        </div>
      )}

      {/* Stats row - total + type filter buttons */}
      <div className="cl-summary-row">
        <div className="cl-total-card">
          <span className="cl-total-label">
            {typeFilter === "all" ? "Total Collected" : typeFilter}
          </span>
          <span className="cl-total-amount">₹{totalAmount.toLocaleString("en-IN")}</span>
          <span className="cl-total-sub">{filtered.length} entr{filtered.length !== 1 ? "ies" : "y"}</span>
        </div>
        <div className="cl-type-pills">
          <button
            className={`cl-type-pill ${typeFilter === "all" ? "cl-type-active" : ""}`}
            onClick={() => setTypeFilter("all")}
          >All</button>
          {uniqueTypes.map(t => (
            <button
              key={t}
              className={`cl-type-pill ${typeFilter === t ? "cl-type-active" : ""}`}
              onClick={() => setTypeFilter(t === typeFilter ? "all" : t)}
            >{t}</button>
          ))}
        </div>
      </div>

      {/* Filters */}
      <div className="dp-filters">
        <input
          className="dp-search"
          placeholder="Search by type, amount or notes…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <select className="dp-select" value={sortOrder} onChange={e => setSortOrder(e.target.value)}>
          <option value="desc">Newest First</option>
          <option value="asc">Oldest First</option>
        </select>
        <span className="dp-count">{filtered.length} records</span>
      </div>

      {/* List */}
      {loading ? (
        <div className="dp-loading"><div className="dp-spinner"/><p>Loading…</p></div>
      ) : filtered.length === 0 ? (
        <div className="dp-empty"><span>📭</span><p>No collection entries found.</p></div>
      ) : (
        <div className="dp-list">
          {filtered.map(col => {
            const isOpen = expanded === col.id;
            return (
              <div key={col.id} className={`dp-card ${isOpen ? "dp-card-open" : ""}`}>
                <div className="dp-card-header" onClick={() => setExpanded(isOpen ? null : col.id)}>
                  <div className="dp-card-left">
                    <span className="cl-amount-pill">₹{parseFloat(col.amount || 0).toLocaleString("en-IN")}</span>
                    <span className="dp-card-name">{col.type || "Unknown"}</span>
                    <span className="dp-card-sub">{formatDate(col.date)}{col.notes ? ` · ${col.notes}` : ""}</span>
                  </div>
                  <span className="dp-chevron">{isOpen ? "▲" : "▼"}</span>
                </div>

                {isOpen && (
                  <div className="dp-card-body">
                    <div className="dp-info-grid">
                      <div className="dp-info-item">
                        <span className="dp-info-key">Amount</span>
                        <span className="dp-info-val" style={{fontWeight:700,fontSize:"1.1rem",color:"#27ae60"}}>
                          ₹{parseFloat(col.amount||0).toLocaleString("en-IN")}
                        </span>
                      </div>
                      <div className="dp-info-item">
                        <span className="dp-info-key">Type</span>
                        <span className="dp-info-val">{col.type || "—"}</span>
                      </div>
                      <div className="dp-info-item">
                        <span className="dp-info-key">Date</span>
                        <span className="dp-info-val">{formatDate(col.date)}</span>
                      </div>
                      {col.notes && (
                        <div className="dp-info-item dp-info-full">
                          <span className="dp-info-key">Notes</span>
                          <span className="dp-info-val">{col.notes}</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Collection;